import styled from 'styled-components';

interface Props {
  isActive: boolean;
  handlePushToggle: () => void;
}

function SwitchButton({ isActive, handlePushToggle }: Props) {
  return (
    <ToggleWrapper $isOn={isActive} onClick={handlePushToggle}>
      <ToggleCircle $isOn={isActive} />
    </ToggleWrapper>
  );
}

export default SwitchButton;

const ToggleWrapper = styled.div<{ $isOn: boolean }>`
  width: 42px;
  height: 22px;
  border-radius: 999px;
  background-color: ${({ $isOn }) =>
    $isOn ? '#008AFF' : 'rgba(55, 56, 60, 0.16)'};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const ToggleCircle = styled.div<{ $isOn: boolean }>`
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.3s ease;
  transform: ${({ $isOn }) =>
    $isOn ? 'translateX(10px)' : 'translateX(-10px)'};
`;
